export default __webpack_public_path__ + "static/illustration-content-logo.url-dac7eef9d58345d6f3418d6d246e719b.svg";